import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  ARTICLE_TYPE_LABELS,
  resolveLabel,
} from '@daas-consulting/production/shared/cross/report_labels';

/**
 * Los colores viven acá (son presentación pura); las etiquetas vienen de la lib
 * cross compartida con el backend, para que la vista, el Excel y la impresión
 * digan siempre lo mismo. Ambos catálogos son abiertos: un tipo sin entrada cae
 * al valor crudo con el punto gris.
 */
const COLORS: Record<string, string> = {
  bag: 'fill-blue-500',
  guia: 'fill-green-500',
  filtro: 'fill-purple-500',
};

@Component({
  selector: 'daas-consulting-shared-article-type',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './article-type.component.html',
  styleUrl: './article-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleTypeComponent implements OnChanges {
  @Input() type = '';
  @Input() removable = false;
  @Output() readonly removed: EventEmitter<void> = new EventEmitter<void>();

  #label = '';
  #color = 'fill-gray-500';

  get label(): string {
    return this.#label;
  }

  get color(): string {
    return this.#color;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ngOnChanges(changes: SimpleChanges): void {
    this._calculate();
  }

  handleRemove($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.removed.emit();
  }

  private _calculate(): void {
    this.#label = resolveLabel(ARTICLE_TYPE_LABELS, this.type, '');
    this.#color = COLORS[this.type] ?? 'fill-gray-500';
  }
}
